import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useTeamsStore = defineStore('teams', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getTeams: (state) => state.data?.data,
    getTeamOptions: (state) => state.options?.data,
    getTeamsGroupedByResource: (state) => {
      const groupedTeams = state.data?.data
          ?.filter(p => {
            const [action] = p.name.split(':', 1);
            return ['create', 'read', 'update', 'delete'].includes(action);
          })
          .reduce((previous, team) => {
            const [action, resource] = team.name.split(':', 2);
            if (!previous.hasOwnProperty(resource)) {
              previous[resource] = {
                create: null,
                read: null,
                update: null,
                delete: null,
              };
            }
            previous[resource][action] = {
              ...team,
              action,
            };
            return previous;
          }, {}) || {};

      // sort the keys on the object
      return Object.fromEntries(Object.entries(groupedTeams).sort());
    }
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexTeamOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'teams', ['id', 'name', 'display_name', 'description']);
          const response = await axios.get('teams', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexTeams(params = {}) {
      try {
        const response = await axios.get('teams', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createTeam(params = {}) {
      try {
        const response = await axios.get('teams/create', {params});
        return useCreateForm('teams', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showTeam(teamId, params = {}) {
      try {
        const response = await axios.get(`teams/${ teamId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editTeam(teamId, params = {}) {
      try {
        const response = await axios.get(`teams/${ teamId }/edit`, {params});
        return useEditForm(`teams/${ teamId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteTeam(teamId, params = {}) {
      try {
        const response = await axios.delete(`teams/${ teamId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Team Deleted',
          detail: `Team has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
